export const URLS_STORAGE_KEY_PREFIX = "_urlsn";

export interface UrlItems {
    [key: string]: string;
}
